import React from "react"

const TopTitEn = ({
  text = text
}) => {
  return <span className="toptit__en">{text}</span>
}

export default TopTitEn